import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "./TrustSection.css";

// Replace these with your actual icons/images
import AuthenticIcon from "../../assets/icons/success.png";
import DeliveryIcon from "../../assets/icons/delivery.png";
import PremiumIcon from "../../assets/icons/crown.png";
import SupportIcon from "../../assets/icons/customer-service.png";

const trustData = [
    { id: 1, icon: AuthenticIcon, label: "Authentic Products" },
    { id: 2, icon: DeliveryIcon, label: "Fast Delivery" },
    { id: 3, icon: PremiumIcon, label: "Premium Brands" },
    { id: 4, icon: SupportIcon, label: "Expert Support" },
];

export default function TrustSection() {
  return (
    <div className="trust-section"> 
      <div className="trust-grid-desktop">
        {trustData.map((item, index) => (
          <div key={item.id} className="trust-card">
            <div className="trust-card-inner">
              <img src={item.icon} alt={item.label} className="trust-icon" />
              <p className="trust-label">{item.label}</p>
            </div>
            {index < trustData.length - 1 && <div className="trust-divider" />}
          </div>
        ))}
      </div>

      {/* Mobile / Tablet Swiper */}
      <div className="trust-swiper-wrapper">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={0}
          slidesPerView={2}
          loop={true}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          className="trust-swiper"
        >
          {trustData.map((item, index) => (
            <SwiperSlide key={item.id}>
              <div className="trust-card">
                <div className="trust-card-inner">
                  <img src={item.icon} alt={item.label} className="trust-icon" />
                  <p className="trust-label">{item.label}</p>
                </div>
                {/* Divider for all cards except last */}
                <div className="trust-divider" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}